module.exports = __webpack_public_path__ + "static/media/galerija_2017 (11).d47dce00.jpg";